import { render, staticRenderFns } from "./CoursePricing.vue?vue&type=template&id=f4725d14&scoped=true"
import script from "./CoursePricing.vue?vue&type=script&lang=js"
export * from "./CoursePricing.vue?vue&type=script&lang=js"
import style0 from "./CoursePricing.vue?vue&type=style&index=0&id=f4725d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4725d14",
  null
  
)

export default component.exports